import { freelancerFeedbackForm } from './feedback-form';
import { freelancerAcceptPopup } from './freelancer-accept-popup';
import { freelancerCard } from './freelancer-card';
import { freelancerCardEdit } from './freelancer-card-edit';
import { freelancerCustomers } from './freelancer-customers';
import { freelancersList } from './freelancers-list';

export const freelancers = {
    freelancerCard,
    freelancerCustomers,
    freelancerFeedbackForm,
    freelancerAcceptPopup,
    freelancerCardEdit,
    freelancersList
};
